import styles from '../cssModules/index.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Form } from 'react-bootstrap';


export function UmbrellaRepeat({ prod, setProdInfo, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');

    const color = ['red', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];
    const size = [
        'Up to 44 cm',
        '45 to 74 cm',
        '75 to 99 cm',
        '100 cm & above']
        ;

    const userSegment = ['Men', 'Women', 'Unisex'];

    const design = [
        'Solid',
        'Floral',
        'Cartoon',
        'Animal Print',
        'Camouflage',
        'Checkered',
        'Chevron',
        'Fruits',
        'Geometric',
        'Heart',
        'Leaf',
        'Moire',
        'Plaid',
        'Polka Dots',
        'Stars',
        'Striped'
    ]

    const specialFeatuee = [
        'Waterproof',
        'Windproof',
        'UV Blocking',
        'Fade Resistant',
        'Heavy Duty Fabric',
        'Lighted',
        'UV Resistant',
        'Adjustable Height',
        'Adjustable Hem Cord',
        'Attached Tie Wrap',
        'Auto Close',
        'Auto-Open',
        'Cantilever',
        'Click Close Strap',
        'Compact',
        'Double Canopy',
        'Foldable',
        'Locking Peg',
        'Padded Handle',
        'Pointed Pole Tip',
        'Portable',
        'Quick Drying',
        'Reflective Trim',
        'Reinforced Frame',
        'Rust Resistant',
        'Stain Resistant',
        'Tear Resistant',
        'Telescopic',
        'Vented',
        'Water Resistant'
    ];

    const material = [
        'Alloy Steel',
        'Aluminium',
        'Fibreglass',
        'Bamboo',
        'Carbon Fibre',
        'Iron',
        'Metal',
        'Plastic',
        'Resin',
        'Stainless Steel',
        'Wood'
    ];

    const openingMechanism = [
        'Auto Open Button',
        'Crank Lift',
        'Manual Lift',
        'Pulley Lift'
    ]

    const width = [
        'Up to 49 cm',
        '50 to 94 cm',
        '95 to 149 cm',
        '150 cm & above'
    ];

    const shape = [
        'Round',
        'Octagonal',
        'Half Round',
        'Bubble',
        'Flower',
        'Hexagonal',
        'Oval',
        'Rectangular',
        'Square',
        'Triangular'
    ];

    const outMaterial = [
        'Polyester',
        'Nylon',
        'Metal',
        'ABS',
        'Canvas',
        'Fabric',
        'Leather',
        'Polycarbonate',
        'Polypropylene',
        'Synthetic'
    ];

    const lifeStyle = [
        'Modern',
        'Classic',
        'Tropical',
        'Bohemian',
        'Southwest'
    ]

    const shaftMaterial = [
        'Metal',
        'Aluminium',
        'Iron',
        'Alloy Steel',
        'Carbon Fiber',
        'Chrome',
        'Fiberglass',
        'Plastic',
        'Stainless Steel',
        'Wood'
    ];

    const stock = ['In stock', 'Out of stock']

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)']

    const [pht1, setpht1] = useState();
    const [pht2, setpht2] = useState();
    const [pht3, setpht3] = useState();
    const [pht4, setpht4] = useState();
    const [pht5, setpht5] = useState();
    const [sizeImage, setSizeImage] = useState();

    const navigate = useNavigate();

    function checkFileSize(file) {
        if (file.size > 500000) {
            alert('File size should be less than 500 KB');
            return false;
        } else {
            return true;
        }
    }

    const ph1Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht1(e.target.files[0]);
    }
    const ph2Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht2(e.target.files[0]);
    }
    const ph3Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht3(e.target.files[0]);
    }
    const ph4Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht4(e.target.files[0]);
    }
    const ph5Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht5(e.target.files[0]);
    }
    const sizeChartUpload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setSizeImage(e.target.files[0]);
    }

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e, msg) => {
        try {
            e.preventDefault();
            const images = [pht1, pht2, pht3, pht4, pht5, sizeImage];
            if (!(pht1 && pht2 && pht3 && pht4 && pht5 && sizeImage)) return;

            const formData = new FormData();
            images.forEach((image) => {
                formData.append('images', image);
            });
            formData.append('product', JSON.stringify(prod));

            const response = await fetch(`${apiURL}/api/upload/image`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                body: formData,
                credentials: 'include'
            })

            if (response.status === 500) {
                throw new Error('Error while uploading product!');
            } else {

                if (response.status === 200) {
                    if (msg === 'repeat') {
                        // let data = await response.json();
                        // let prodId = data['prodId'];
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    } else {
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    }
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            console.log(error.message);
            await loginStatus();
            navigate('/login');
        }
    }

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prod = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prod['additionsize'], [size]: Number(stock) };
                setProdInfo(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prod['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prod['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prod["additionsize"], [size]: null }
                    setProdInfo(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prod.additionsize &&
                (<div className={`${styles.sellerUploadmainDiv}`}>
                    <form id='uploadForm' onSubmit={(e) => handleSubmit(e, 'form')} className={`${styles.sellerUploadForm}`}>
                        <div className={`${styles.sellerUploadDiv}`}>
                            <div className={`${styles.sellerUploadPhotoSecDiv}`}>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph1'>
                                        Choose photo 1
                                    </label>
                                    <input id='ph1' type='file' onChange={ph1Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph2'>
                                        Choose photo 2
                                    </label>
                                    <input id='ph2' type='file' onChange={ph2Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph3'>
                                        Choose photo 3
                                    </label>
                                    <input id='ph3' type='file' onChange={ph3Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph4'>
                                        Choose photo 4
                                    </label>
                                    <input id='ph4' type='file' onChange={ph4Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='ph5'>
                                        Choose photo 5
                                    </label>
                                    <input id='ph5' type='file' onChange={ph5Upload} required={true} accept='image/*' />
                                </div>
                                <div className={`${styles.sellerUploadPhotoInput}`}>

                                    <label for='sizeChart'>
                                        Choose size chart
                                    </label>
                                    <input id='sizeChart' type='file' onChange={sizeChartUpload} required={true} accept='image/*' />
                                </div>
                            </div>
                            <div className={`${styles.selleruploadFormDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.color} selected hidden>{prod.color}</option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='user'>
                                        User segment
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='user' name='userSegment' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.userSegment} selected hidden>{prod.userSegment}</option>
                                        {userSegment.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='material'>
                                        Material
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='material' name='material' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.material} selected hidden>{prod.material}</option>
                                        {material.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='lifeStyle'>
                                        LifeStyle
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='lifeStyle' required name='lifeStyle' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.lifeStyle} selected hidden>{prod.lifeStyle}</option>
                                        {lifeStyle.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='specialFeature'>
                                        Special feature
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='specialFeature' required name='specialFeature' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.specialFeature} selected hidden>{prod.specialFeature}</option>
                                        {specialFeatuee.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='openingMechanism'>
                                        Opening mechanism
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='openingMechanism' required name='openingMechanism' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.openingMechanism} selected hidden>{prod.openingMechanism}</option>
                                        {openingMechanism.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='width'>
                                        Width
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='width' required name='width' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.width} selected hidden>{prod.width}</option>
                                        {width.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='shape'>
                                        Shape
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='shape' required name='shape' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.shape} selected hidden>{prod.shape}</option>
                                        {shape.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='outMaterial'>
                                        Outer material
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='outMaterial' required name='outMaterial' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.outMaterial} selected hidden>{prod.outMaterial}</option>
                                        {outMaterial.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='shaftMaterial'>
                                        Shaft material
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='shaftMaterial' required name='shaftMaterial' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.shaftMaterial} selected hidden>{prod.shaftMaterial}</option>
                                        {shaftMaterial.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='design'>
                                        Design
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='design' required name='design' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.design} selected hidden>{prod.design}</option>
                                        {design.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' required name='active' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.active} selected hidden>{prod.active}</option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>

                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' required name='weightCat' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                        <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input
                                        className={`${styles.sellerUploadSelect}`}
                                        id='name'
                                        defaultValue={prod.name}
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="Name of the product" name='name' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='price'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='price'
                                        defaultValue={prod.oldPrice}
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true}
                                        type='number' placeholder="price" name='oldPrice' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='discountP'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`}
                                        id='discountP'
                                        defaultValue={prod.currentPrice}
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true}
                                        type='number' placeholder="This price will be highlighted" name='currentPrice' />
                                </div>
                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        In stock
                                    </label>
                                    <input
                                        className={`${styles.sellerUploadSelect}`}
                                        id='stock'
                                        defaultValue={prod.stock}
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='number' placeholder="Total stock available" name='stock' />
                                </div> */}
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Sizes</Dropdown.Toggle>
                                        <Dropdown.Menu
                                        // bsPrefix={`form-control, ${styles.dropdownMenu}`}
                                        >
                                            {size.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prod['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prod['additionsize'][option] ? prod['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                        onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                        required={true}
                                        type='text'
                                        placeholder="SKU"
                                        name='sku' />
                                </div>
                            </div>
                        </div>
                        <input type="submit" value='UPLOAD' className={`${styles.sellerUploadBtn}`} />
                        <button className={`${styles.uploadRepeat}`}
                            onClick={(e) => { handleSubmit(e, 'repeat') }}>Upload & Repeat</button>
                    </form >
                </div >)
            }
        </>
    )
}